<template>
    <v-dialog persistent v-model="dialog" content-class="my-custom-dialog" width="280px">
        <v-card flat>
            <v-card-title>
                Export week list to Excel
            </v-card-title>
            <v-card-text>                
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 20px;">
                    <div style="width: 60px;">
                        <v-text-field v-model="week" type="number" label="Weeknr"></v-text-field>
                    </div>
                    <div style="width: 60px;">
                        <v-text-field v-model="year" type="number" label="Year"></v-text-field>
                    </div>                    
                    <div style="margin-right: 8px; cursor: pointer; width: 40px; margin-left: auto;">
                        <div v-if=loading>
                            <v-progress-circular :width="3" :size="20" color="green" indeterminate></v-progress-circular>
                        </div>
                        <div v-else> 
                            <v-icon medium color="green" @click="getNewAccos()">mdi-microsoft-excel</v-icon>
                        </div>
                    </div>
                </div>                                               
            </v-card-text>
            <v-card-actions >
                <v-spacer></v-spacer>    
                <v-btn small @click="close" color="primary" :disabled="loading">
                    cancel
                </v-btn>                  
            </v-card-actions>                    
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            loading: false,
            new_accos: [],
            week: 0,
            year: 0,
        }
    },
    created(){ 
    },                  
    mounted(){            
    },        
    methods:{
        open() {
            this.dialog = true   
            this.week = this.getThisWeekNumber()
            this.year = this.getThisYearNumber()
        },           
        close(){
            this.dialog = false   
        },  
        getThisWeekNumber(){
            let w = this.$moment(new Date()).isoWeek() - 1
            return w===0?this.$moment(new Date((new Date().getFullYear() - 1), 11, 31, 0, 0, 0)).isoWeek():w
        },
        getThisYearNumber(){
            let w = this.$moment(new Date()).isoWeek() - 1
            return w===0?this.$moment(new Date()).year()-1:this.$moment(new Date()).year() // default
        },        
        getStartDateWeekIso(w, y){
            return this.$moment().year(y).week(w).day(1).format('YYYY-MM-DD')
        },
        getEndDateWeekIso(w, y){
            return this.$moment().year(y).week(w).day(7).format('YYYY-MM-DD')
        },        
        exportDataToExcel() {
            console.log('export function')
            this.loading = true;
            this.$axios
                .post("ares/json/ares/syst/dashboard/exportNewAccolist.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        week: this.week,
                        request: "export"
                    },
                    export: this.new_accos,
                })
                .then(res => {
                    if (res.data.error) {
                        this.loading = false;
                        console.log(res.data.error);
                    } else {
                        this.loading = false;
                        this.items = res.data.export;
                        window.open(this.items.filename, '_blank');
                    }
                })
        },
        getNewAccos(){
            this.loading=true
            this.$axios
                .post("ares/json/ares/syst/dashboard/getNewAccommodationPerWeek.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getNewAccommodationPerWeek"
                },
                getNewAccommodationPerWeek: {
                    startdate: this.getStartDateWeekIso(this.week, this.year),
                    enddate: this.getEndDateWeekIso(this.week, this.year),
                }
                })
                .then(async res => {
                    if (res.data.error) {
                        this.loading=false;
                        console.log(res.data.error);
                    } else {
                        this.loading=false;
                        this.new_accos = res.data.accos;
                        await this.exportDataToExcel()
                        this.close()
                    }
                })
        }
    }
}        
</script>

<style scoped>
  >>> .my-custom-dialog {
    margin-bottom: auto !important;
    margin-right: auto !important;
    margin-left: 120px !important;
    margin-top: 120px !important;
  }
</style>